import {createSelector} from "reselect";

export const getLoadingAnnotation = state => state.annotations.loading;

export const getAnnotations = state => state.annotations.listAnnotation && Object.values(state.annotations.listAnnotation);
